import React from "react";
import Game from "./Game";
import {prepareInfobox, shuffle, domain} from "./utils";
import Question from "./Question";
import { Map } from "../../maps";


class Quiz extends Game {
  GAME_NAME = 'quiz';
  CONGRATULATION = 'прошёл викторину';
  CONGRATULATION_PLURAL = 'прошли викторину';
  HEADER = 'Викторина'
  CAPTION = 'По флагу, названию или столице найдите страну/регион на карте и нажмите на ней.'

  constructor(props) {
    super(props);
    this.state = {...this.state, question: null, questions: []};
  }

  static extractData(polygons, solved) {
    return polygons.map(polygon => {
      return {
        id: polygon.id,
        draggable: false,
        isSolved: false,
        infobox: {name: polygon.name, loaded: false},
        paths: []
      }
    }).concat(solved.map(region => {
      return {
        id: region.id,
        draggable: false,
        isSolved: true,
        infobox: region.infobox,
        paths: Map.preparePolygon(region.polygon)
      }
    })).sort((one, another) => {
      return one.infobox.name > another.infobox.name ? 1 : -1
    });
  }

  static prepareQuestions(questions) {
    return shuffle(questions
      .map(question => {
        return ['name', 'flag', 'coat_of_arms', 'capital']
          .map(key => {
            if (question[key] === undefined) {
              return null;
            }
            let result = {id: question.id};
            result[key] = question[key];
            return result;
          })
          .filter(item => item !== null);
    }).reduce((l, acc) => {acc = acc.concat(l); return acc}, []));
  }

  changeRegionState(data, current) {
    let regions = this.state.regions.map((polygon) => {
      if (polygon.id === data.id) {
        return {
          draggable: false,
          id: data.id,
          isSolved: data.type === 'QUIZ_CHECK_SUCCESS',
          infobox: {...data.infobox, loaded: true},
          paths: Map.preparePolygon(data.polygon),
        };
      }
      return polygon;
    });
    let questions = this.state.questions.filter(element => {return element.id !== data.id});
    let index = current === null ? this.state.question % questions.length : questions.findIndex(item => item.id === current.id);
    if (index === -1) {
      index = this.state.question % questions.length;
    }
    let infobox = current === null ? {...data.infobox} : this.state.infobox;
    this.setState({...this.state, regions: regions, infobox: infobox, questions: questions, question: index}, () => {
      if (this.state.regions.length > 0 && this.state.regions.filter(el => el.isSolved === false).length === 0) {
        let time = new Date(Date.now() - this.state.startTime);
        this.showCongratulation(time.toLocaleTimeString('ru-RU', {timeZone: 'UTC'}));
      }
    });
  }

  dispatchMessage = (event) => {
    let data = JSON.parse(event.data);
    switch(data.type) {
      case 'QUIZ_CHECK_SUCCESS':
      case 'QUIZ_GIVEUP_DONE':
        this.changeRegionState({...data, infobox: prepareInfobox(data.infobox)}, null);
        break;
      case 'QUIZ_FOUND':
        this.changeRegionState(data, this.state.questions[this.state.question]);
        break;
    }
  };

  mapClick = (lat, lng) => {
    let question = this.state.questions[this.state.question];
    if (question) {
      this.wsSend({type: 'QUIZ_CHECK', coords: {lat: lat, lng: lng}, id: question.id});
    }
  };

  loadData = (options) => {
    let get_params = '?params=name,flag,capital';
    fetch(`${domain("http")}/quiz/${this.props.slug}/questions/${get_params}`)
      .then(response => response.json())
      .then(data => {
        let regions = Quiz.extractData(data.questions, data.solved);
        this.startGame({regions: regions, questions: Quiz.prepareQuestions(data.questions), question: 0});
      })
      .catch(response => {this.setState({...this.state, isLoaded: false})});
  };

  giveUp = () => {
    this.wsSend({type: 'QUIZ_GIVEUP', id: this.state.questions[this.state.question].id});
  };

  onNext = () => {
    this.setState({...this.state, question: (this.state.question + 1) % this.state.questions.length});
  };

  onPrevious = () => {
    let index = this.state.question - 1;
    this.setState({...this.state, question: index < 0 ? this.state.questions.length - 1 : index});
  };

  renderQuestion() {
    return <Question giveUp={this.giveUp} question={this.state.question} questions={this.state.questions}
                     onNext={this.onNext} onPrevious={this.onPrevious}/>;
  }
}


export default Quiz;
